import { render, staticRenderFns } from "./PromotionComponent.vue?vue&type=template&id=587d904c&scoped=true"
import script from "./PromotionComponent.vue?vue&type=script&lang=js"
export * from "./PromotionComponent.vue?vue&type=script&lang=js"
import style0 from "./PromotionComponent.vue?vue&type=style&index=0&id=587d904c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d904c",
  null
  
)

export default component.exports